import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import useRoles from 'common/hooks/useRoles';
import ShipmentsPage from './components/ShipmentsPage';
import { fetchAllCounts, fetchShipmentsByPage } from '../../store/thunks/shipmentModuleThunks';
import { getPartners } from '../../store/thunks/partnerThunks';
import { listShippingOptions } from '../../store/thunks/batchShipmentThunk';

const Shipments = () => {
  const dispatch = useDispatch();
  const partners = useSelector(({ auth, partner }) => partner[auth.currentTenantId]);
  const shippingOptions = useSelector(({ systemConfigs }) => systemConfigs?.shippingOptions);
  const { viewShipments } = useRoles();

  useEffect(() => {
    if (viewShipments) {
      dispatch(fetchAllCounts());
      dispatch(fetchShipmentsByPage({ page: 1 }));
    }
  }, [dispatch, viewShipments]);

  useEffect(() => {
    if (isEmpty(partners)) {
      dispatch(getPartners());
    }
    if (isEmpty(shippingOptions)) {
      dispatch(listShippingOptions());
    }
  }, [dispatch, partners, shippingOptions]);

  return <ShipmentsPage />;
};

export default Shipments;
